module.exports = __webpack_public_path__ + "img/bio-purple-slide.508489f.jpg";